import React, { useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const MENU_CATEGORIES = [{
  name: "Vegan",
  color: "#6FCF97",
  colorSoft: "#eafbf1",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 21c-4-2-7-6-7-11 0-3 2-6 7-7 5 1 7 4 7 7 0 5-3 9-7 11z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M12 21V9" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
      </svg>,
  items: [{
    value: "Marinara (Vegan)",
    label: "Marinara"
  }]
}, {
  name: "Vegetarisch",
  color: "#8B9B2E",
  colorSoft: "#f3f6e3",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M3 12a9 9 0 0118 0z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M3 12h18" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="12" cy="8.5" r="1.3" fill="currentColor" />
      </svg>,
  items: [{
    value: "Margherita (Vegetarisch)",
    label: "Margherita"
  }, {
    value: "Verdechiosa (Vegetarisch)",
    label: "Verdechiosa"
  }, {
    value: "Pera (Vegetarisch)",
    label: "Pera"
  }]
}, {
  name: "Meat Lovers",
  color: "#E15B4E",
  colorSoft: "#fdeae7",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M8 3c4 0 7.5 3 7.5 7 0 3-2 5.5-4.5 6.5L9 21l-2-1 1.5-4C6 15 4.5 12.5 4.5 10 4.5 6.5 6 4 8 3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      </svg>,
  items: [{
    value: "Forestella (Meat Lovers)",
    label: "Forestella"
  }, {
    value: "Rossochiosa (Meat Lovers)",
    label: "Rossochiosa"
  }, {
    value: "Pistacchiosa (Meat Lovers)",
    label: "Pistacchiosa"
  }]
}, {
  name: "Sweet",
  color: "#F2A6C0",
  colorSoft: "#fdeef4",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 3c1.5 2 1.5 3.5 0 5-1.5-1.5-1.5-3 0-5z" fill="currentColor" />
        <path d="M6 10h12l-1.2 8.5a2 2 0 01-2 1.5H9.2a2 2 0 01-2-1.5L6 10z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M6 10a6 6 0 0112 0" stroke="currentColor" strokeWidth="1.6" />
      </svg>,
  items: [{
    value: "Stella dolce (Sweet)",
    label: "Stella dolce"
  }]
}];
const EVENT_TYPES = [{
  value: "Privates Event",
  label: "Privates Event",
  hint: "max. 4 Pizzen",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 3l8 4.5v9L12 21l-8-4.5v-9L12 3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
        <path d="M12 3v18M4 7.5l8 4.5 8-4.5" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      </svg>
}, {
  value: "Berufliches Event",
  label: "Berufliches Event",
  hint: "max. 5 Pizzen",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <rect x="3" y="7" width="18" height="13" rx="2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M8 7V5a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2" stroke="currentColor" strokeWidth="1.6" />
        <path d="M3 12h18" stroke="currentColor" strokeWidth="1.6" />
      </svg>
}, {
  value: "Hochzeit",
  label: "Hochzeit",
  hint: "max. 6 Pizzen",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <circle cx="8" cy="15" r="4.5" stroke="currentColor" strokeWidth="1.6" />
        <circle cx="16" cy="15" r="4.5" stroke="currentColor" strokeWidth="1.6" />
        <path d="M12 6l1.8 3.6L18 10l-3.5 2.3.7 4.1-3.2-2.3-3.2 2.3.7-4.1L6 10l4.2-.4L12 6z" fill="currentColor" />
      </svg>
}];
const SETUP_TYPES = [{
  value: "Light Setup",
  label: "Light Setup",
  hint: "Küche wird vom Kunden gestellt",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M12 2v4M6.5 5.5l2.5 2.5M17.5 5.5L15 8M4 14a8 8 0 0116 0" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M3 14h18" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M4 17h16l-1 3H5l-1-3z" stroke="currentColor" strokeWidth="1.6" strokeLinejoin="round" />
      </svg>
}, {
  value: "Full Setup",
  label: "Full Setup",
  hint: "Küche wird von Namo bereitgestellt",
  icon: <svg viewBox="0 0 24 24" fill="none">
        <path d="M6 3v7a3 3 0 003 3v8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M6 3v7M9 3v7" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" />
        <path d="M16 3c-1.7 0-3 2-3 5s1.3 5 3 5v8" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
}];
const EVENT_MAX = {
  "Privates Event": 4,
  "Berufliches Event": 5,
  Hochzeit: 6
};
const FORCED_FULL_SETUP_EVENTS = ["Berufliches Event", "Hochzeit"];
export default function ContactForm() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  const [eventType, setEventType] = useState("");
  const [setup, setSetup] = useState("");
  const [selectedMenu, setSelectedMenu] = useState([]);
  const [time, setTime] = useState("");
  const eventMax = EVENT_MAX[eventType] || 6;
  const setupLocked = FORCED_FULL_SETUP_EVENTS.includes(eventType);
  const maxPizzas = setup === "Light Setup" ? Math.min(4, eventMax) : eventMax;
  const limitReached = selectedMenu.length >= maxPizzas;
  const toggleMenu = value => {
    setSelectedMenu(prev => {
      if (prev.includes(value)) return prev.filter(v => v !== value);
      if (prev.length >= maxPizzas) return prev;
      return [...prev, value];
    });
  };
  return <section id="contactform" ref={ref} className={cn("w-full py-16 md:py-24 text-foreground overflow-hidden transition-opacity duration-700", isVisible ? "opacity-100" : "opacity-0")} style={{
    backgroundColor: "#436C1A"
  }}>
      <div className="max-w-5xl mx-auto px-4 md:px-8">

        {}
        <div className={cn("mb-12 text-center transition-all duration-700", isVisible ? "translate-y-0 opacity-100" : "translate-y-8 opacity-0")}>
          {}
          <div className="flex justify-center mb-6">
            <div className="w-16 h-1 rounded-full bg-gradient-to-r from-[#8B9B2E] to-[#2D6A2D]" />
          </div>

          {}
          <h2 className="text-4xl md:text-5xl font-display font-extrabold text-white leading-tight mb-5">
            {["Planen", "Sie", "Ihr"].map((word, i) => <span key={`${word}-${i}`} className={cn("inline-block mr-3 transition-all duration-500", isVisible ? "translate-y-0 opacity-100" : "translate-y-6 opacity-0")} style={{
            transitionDelay: isVisible ? `${i * 100}ms` : "0ms"
          }} data-index={i}>
                {word}
              </span>)}
            <span className="inline-block transition-all duration-500 translate-y-0 opacity-100 !text-[rgba(5,5,4,1)]" style={{
            transitionDelay: isVisible ? "300ms" : "0ms"
          }}>
              Event
            </span>
          </h2>

          {}
          <p className="text-base max-w-2xl mx-auto leading-relaxed transition-all duration-700 translate-y-0 opacity-100 !font-semibold !text-[rgba(255,255,255,1)] md:text-lg" style={{
          transitionDelay: isVisible ? "450ms" : "0ms"
        }}>
            Ob private Feier, berufliche Veranstaltung oder Hochzeit. Wir
            gestalten unvergessliche kulinarische Erlebnisse. Füllen Sie das
            Formular aus und wir erstellen ein maßgeschneidertes Angebot für
            Ihren besonderen Anlass.
          </p>

          {}
          <div className="mt-10">
            <style>{`
              @keyframes namoFadeUp {
                from { opacity: 0; transform: translateY(14px); }
                to { opacity: 1; transform: translateY(0); }
              }
              @keyframes namoPulseBorder {
                0% { box-shadow: 0 0 0 0 rgba(252,194,45,0.55); }
                70% { box-shadow: 0 0 0 8px rgba(252,194,45,0); }
                100% { box-shadow: 0 0 0 0 rgba(252,194,45,0); }
              }
              @keyframes namoPop {
                0% { transform: scale(0.9); }
                50% { transform: scale(1.06); }
                100% { transform: scale(1); }
              }
              @keyframes namoCheckIn {
                from { opacity: 0; transform: scale(0) rotate(-45deg); }
                to { opacity: 1; transform: scale(1) rotate(0deg); }
              }
              @keyframes namoFloat {
                0%, 100% { transform: translateY(0) rotate(0deg); }
                50% { transform: translateY(-4px) rotate(4deg); }
              }
              @keyframes namoDrawLine {
                from { width: 0; }
                to { width: 100%; }
              }
              @keyframes namoRingExpand {
                0% { transform: scale(1); opacity: 0.5; }
                100% { transform: scale(1.9); opacity: 0; }
              }
              .namo-form-wrapper {
                background: linear-gradient(160deg, #436C1A 0%, #375a15 100%);
                padding: 40px 24px;
                border-radius: 20px;
                border: 2px solid #FCC12F;
                box-shadow: 0 20px 50px rgba(0,0,0,0.25);
              }
              .namo-form {
                max-width: 720px;
                margin: 0 auto;
                font-family: sans-serif;
                color: #ffffff;
                text-align: left;
              }
              .namo-section {
                animation: namoFadeUp 0.6s ease both;
              }
              .namo-form h3 {
                color: #FCC22D;
                font-weight: 800;
                margin-top: 36px;
                margin-bottom: 10px;
                font-size: 1.4rem;
                position: relative;
                display: inline-block;
              }
              .namo-form h3::after {
                content: "";
                position: absolute;
                left: 0;
                bottom: -6px;
                height: 3px;
                width: 40px;
                background: #FCC22D;
                border-radius: 4px;
                transition: width 0.4s ease;
              }
              .namo-form h3:hover::after {
                width: 100%;
              }
              .namo-form label {
                display: block;
                font-weight: bold;
                margin-top: 18px;
                margin-bottom: 6px;
                color: #ffffff;
              }
              .namo-form small {
                color: #ffffff;
                opacity: 0.85;
                font-weight: normal;
              }
              .namo-form input,
              .namo-form select,
              .namo-form textarea {
                width: 100%;
                padding: 11px 16px;
                border: 1px solid rgba(252,194,45,0.6);
                border-radius: 20px;
                box-sizing: border-box;
                background: rgba(255,255,255,0.06);
                color: #ffffff;
                font-size: 15px;
                transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
              }
              .namo-form input::placeholder,
              .namo-form textarea::placeholder {
                color: rgba(255,255,255,0.55);
              }
              .namo-form input:focus,
              .namo-form select:focus,
              .namo-form textarea:focus {
                outline: none;
                border-color: #FCC22D;
                background: rgba(255,255,255,0.12);
                box-shadow: 0 0 0 4px rgba(252,194,45,0.18);
              }
              .namo-form select option {
                color: #000000;
              }
              .namo-form textarea {
                border-radius: 16px;
                min-height: 100px;
                resize: vertical;
              }
              .namo-row {
                display: flex;
                gap: 16px;
                flex-wrap: wrap;
              }
              .namo-row > div {
                flex: 1;
                min-width: 200px;
              }

              /* ---- Shared "choice card" style (event type + setup) ---- */
              .namo-choice-grid {
                display: grid;
                grid-template-columns: repeat(auto-fit, minmax(170px, 1fr));
                gap: 12px;
                margin-top: 8px;
              }
              .namo-choice-card {
                position: relative;
                border: 1.5px solid rgba(255,255,255,0.2);
                border-radius: 16px;
                padding: 16px 14px;
                cursor: pointer;
                text-align: center;
                background: rgba(255,255,255,0.04);
                transition: all 0.25s ease;
                overflow: hidden;
              }
              .namo-choice-card input {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
              }
              .namo-choice-check {
                position: absolute;
                top: 10px;
                right: 10px;
                width: 20px;
                height: 20px;
                border-radius: 50%;
                background: #FCC22D;
                color: #436C1A;
                display: flex;
                align-items: center;
                justify-content: center;
                opacity: 0;
                transform: scale(0) rotate(-45deg);
                transition: all 0.3s ease;
              }
              .namo-choice-check svg {
                width: 12px;
                height: 12px;
              }
              .namo-choice-card.active .namo-choice-check {
                opacity: 1;
                transform: scale(1) rotate(0deg);
              }
              .namo-choice-icon {
                width: 30px;
                height: 30px;
                margin: 0 auto 8px;
                color: #FCC22D;
                transition: transform 0.3s ease;
              }
              .namo-choice-icon svg {
                width: 100%;
                height: 100%;
              }
              .namo-choice-label {
                font-weight: 700;
                font-size: 14.5px;
                color: #ffffff;
              }
              .namo-choice-hint {
                font-size: 12px;
                color: rgba(255,255,255,0.6);
                margin-top: 2px;
                line-height: 1.35;
              }
              .namo-choice-card:hover {
                border-color: rgba(252,194,45,0.6);
                transform: translateY(-3px);
              }
              .namo-choice-card:hover .namo-choice-icon {
                transform: scale(1.1) rotate(-4deg);
              }
              .namo-choice-card.active {
                background: rgba(252,194,45,0.15);
                border-color: #FCC22D;
                animation: namoPulseBorder 0.8s ease-out;
              }
              .namo-choice-card.active .namo-choice-hint {
                color: #FCC22D;
              }
              .namo-choice-grid.namo-setup-grid {
                grid-template-columns: repeat(auto-fit, minmax(220px, 1fr));
              }
              .namo-choice-grid.namo-setup-grid .namo-choice-card {
                text-align: left;
                display: flex;
                align-items: center;
                gap: 14px;
                padding: 16px 18px;
              }
              .namo-choice-grid.namo-setup-grid .namo-choice-icon {
                margin: 0;
                flex-shrink: 0;
              }
              .namo-choice-card.disabled {
                opacity: 0.35;
                cursor: not-allowed;
                filter: grayscale(0.4);
              }
              .namo-choice-card.disabled:hover {
                transform: none;
                border-color: rgba(255,255,255,0.2);
              }
              .namo-choice-card.disabled:hover .namo-choice-icon {
                transform: none;
              }
              .namo-choice-lock {
                position: absolute;
                top: 10px;
                right: 10px;
                width: 20px;
                height: 20px;
                color: rgba(255,255,255,0.6);
              }
              .namo-choice-lock svg {
                width: 100%;
                height: 100%;
              }
              .namo-setup-locked-note {
                display: inline-block;
                font-weight: 500;
                font-size: 12.5px;
                color: #FCC22D;
                margin-left: 8px;
                opacity: 0;
                animation: namoFadeUp 0.4s ease forwards;
              }

              /* ---- Time picker ---- */
              .namo-time-wrap {
                display: flex;
                align-items: center;
                gap: 12px;
                border: 1px solid rgba(252,194,45,0.6);
                border-radius: 20px;
                background: rgba(255,255,255,0.06);
                padding: 4px 16px;
                transition: border-color 0.25s ease, box-shadow 0.25s ease, background 0.25s ease;
              }
              .namo-time-wrap:focus-within {
                border-color: #FCC22D;
                background: rgba(255,255,255,0.12);
                box-shadow: 0 0 0 4px rgba(252,194,45,0.18);
              }
              .namo-time-icon {
                width: 20px;
                height: 20px;
                color: #FCC22D;
                flex-shrink: 0;
              }
              .namo-time-wrap input[type="time"] {
                border: none;
                background: transparent;
                padding: 10px 0;
                color: #ffffff;
                font-size: 16px;
                font-weight: 600;
                letter-spacing: 0.02em;
              }
              .namo-time-wrap input[type="time"]:focus {
                outline: none;
                box-shadow: none;
                background: transparent;
              }
              .namo-time-wrap input[type="time"]::-webkit-calendar-picker-indicator {
                filter: invert(1) sepia(1) saturate(5) hue-rotate(5deg);
                cursor: pointer;
                opacity: 0.85;
              }

              /* ---- Menu category headers: animated icon medallion ---- */
              .namo-menu-category {
                margin-top: 30px;
              }
              .namo-menu-category-header {
                display: flex;
                align-items: center;
                gap: 14px;
                margin-bottom: 14px;
              }
              .namo-medallion {
                position: relative;
                width: 42px;
                height: 42px;
                flex-shrink: 0;
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                background: var(--namo-cat-color);
                box-shadow: 0 4px 14px color-mix(in srgb, var(--namo-cat-color) 55%, transparent);
              }
              .namo-medallion::before {
                content: "";
                position: absolute;
                inset: 0;
                border-radius: 50%;
                border: 2px solid var(--namo-cat-color);
                animation: namoRingExpand 2.4s ease-out infinite;
              }
              .namo-medallion svg {
                width: 20px;
                height: 20px;
                color: #1a1a1a;
                animation: namoFloat 3s ease-in-out infinite;
              }
              .namo-menu-category-titlewrap {
                flex: 1;
                min-width: 0;
              }
              .namo-menu-category-title {
                font-size: 1.15rem;
                font-weight: 800;
                letter-spacing: 0.01em;
                color: #ffffff;
                margin: 0;
                line-height: 1.2;
              }
              .namo-menu-category-title .namo-cat-count {
                font-weight: 500;
                font-size: 0.75rem;
                color: rgba(255,255,255,0.55);
                margin-left: 6px;
              }
              .namo-menu-category-line {
                position: relative;
                height: 3px;
                border-radius: 3px;
                background: rgba(255,255,255,0.12);
                margin-top: 6px;
                overflow: hidden;
              }
              .namo-menu-category-line::after {
                content: "";
                position: absolute;
                inset: 0;
                width: 0;
                border-radius: 3px;
                background: var(--namo-cat-color);
                animation: namoDrawLine 0.9s ease forwards;
                animation-delay: 0.15s;
              }

              .namo-menu-grid {
                display: flex;
                flex-wrap: wrap;
                gap: 10px;
              }
              .namo-pizza-chip {
                position: relative;
                display: inline-flex;
                align-items: center;
                gap: 8px;
                padding: 10px 18px;
                border-radius: 999px;
                border: 1.5px solid rgba(255,255,255,0.25);
                background: rgba(255,255,255,0.05);
                color: #ffffff;
                font-size: 14px;
                font-weight: 600;
                cursor: pointer;
                user-select: none;
                overflow: hidden;
                transition: border-color 0.3s ease, background 0.3s ease, transform 0.2s ease, opacity 0.3s ease, color 0.3s ease;
              }
              .namo-pizza-chip:hover:not(.disabled) {
                border-color: var(--namo-cat-color);
                transform: translateY(-2px);
              }
              .namo-pizza-chip.checked {
                background: var(--namo-cat-color);
                border-color: var(--namo-cat-color);
                color: #1a1a1a;
                animation: namoPop 0.35s ease;
              }
              .namo-pizza-chip.disabled {
                opacity: 0.3;
                cursor: not-allowed;
              }
              .namo-pizza-chip input {
                position: absolute;
                opacity: 0;
                width: 0;
                height: 0;
              }
              .namo-pizza-check {
                display: inline-flex;
                width: 16px;
                height: 16px;
                align-items: center;
                justify-content: center;
              }
              .namo-pizza-check svg {
                width: 14px;
                height: 14px;
              }
              .namo-pizza-chip.checked .namo-pizza-check {
                animation: namoCheckIn 0.3s ease;
              }

              .namo-counter {
                display: inline-block;
                margin-top: 18px;
                padding: 5px 14px;
                border-radius: 999px;
                background: rgba(252,194,45,0.15);
                color: #FCC22D;
                font-size: 13px;
                font-weight: 700;
                transition: all 0.3s ease;
              }
              .namo-counter.full {
                background: #FCC22D;
                color: #436C1A;
              }

              .namo-submit {
                margin-top: 30px;
                background: #FCC22D;
                color: #436C1A;
                border: none;
                padding: 15px 28px;
                border-radius: 30px;
                font-weight: 800;
                cursor: pointer;
                width: 100%;
                font-size: 16px;
                transition: transform 0.25s ease, background 0.25s ease, box-shadow 0.25s ease;
              }
              .namo-submit:hover {
                background: #ffffff;
                color: #436C1A;
                transform: translateY(-2px);
                box-shadow: 0 10px 24px rgba(0,0,0,0.25);
              }
              .namo-submit:active {
                transform: translateY(0);
              }
            `}</style>

            <div className="namo-form-wrapper">
              <form className="namo-form" action="https://formsubmit.co/hekuranmorina@icloud.com" method="POST">
                <input type="hidden" name="_cc" value="info.namo@icloud.com" />
                <input type="hidden" name="_subject" value="Neue Event-Anfrage - Namo Catering" />
                <input type="hidden" name="_template" value="table" />
                <input type="hidden" name="_captcha" value="false" />

                {}
                <div className="namo-section">
                  <h3>Kontaktdaten</h3>
                  <div className="namo-row">
                    <div>
                      <label>Vorname *</label>
                      <input type="text" name="Vorname" required />
                    </div>
                    <div>
                      <label>Nachname</label>
                      <input type="text" name="Nachname" />
                    </div>
                  </div>

                  <label>Straße und Hausnummer *</label>
                  <input type="text" name="Kontakt_Strasse" required />

                  <div className="namo-row">
                    <div>
                      <label>Stadt *</label>
                      <input type="text" name="Kontakt_Stadt" required />
                    </div>
                    <div>
                      <label>Postleitzahl *</label>
                      <input type="text" name="Kontakt_PLZ" required />
                    </div>
                  </div>

                  <div className="namo-row">
                    <div>
                      <label>Telefon</label>
                      <input type="tel" name="Telefon" />
                    </div>
                    <div>
                      <label>E-Mail-Adresse *</label>
                      <input type="email" name="Email" required />
                    </div>
                  </div>
                </div>

                {}
                <div className="namo-section" style={{
                animationDelay: "0.1s"
              }}>
                  <h3>Veranstaltungsdetails</h3>

                  <div className="namo-row">
                    <div>
                      <label>Datum *</label>
                      <input type="date" name="Datum" required />
                    </div>
                    <div>
                      <label>Essensbeginn - Uhrzeit *</label>
                      <div className="namo-time-wrap">
                        <svg className="namo-time-icon" viewBox="0 0 24 24" fill="none">
                          <circle cx="12" cy="12" r="9" stroke="currentColor" strokeWidth="1.6" />
                          <path d="M12 7v5l3.5 2" stroke="currentColor" strokeWidth="1.6" strokeLinecap="round" strokeLinejoin="round" />
                        </svg>
                        <input type="time" name="Uhrzeit" required value={time} onChange={e => setTime(e.target.value)} />
                      </div>
                    </div>
                  </div>

                  <label>Art der Veranstaltung *</label>
                  <div className="namo-choice-grid">
                    {EVENT_TYPES.map(et => <label key={et.value} className={cn("namo-choice-card", eventType === et.value && "active")}>
                        <input type="radio" name="Art_der_Veranstaltung" value={et.value} required checked={eventType === et.value} onChange={() => {
                      setEventType(et.value);
                      if (FORCED_FULL_SETUP_EVENTS.includes(et.value)) {
                        setSetup("Full Setup");
                      }
                    }} />
                        <span className="namo-choice-check">
                          <svg viewBox="0 0 24 24" fill="none">
                            <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </span>
                        <div className="namo-choice-icon">{et.icon}</div>
                        <div className="namo-choice-label">{et.label}</div>
                        <div className="namo-choice-hint">{et.hint}</div>
                      </label>)}
                  </div>

                  <label>Personen *</label>
                  <input type="number" name="Personen" min="1" required />

                  <label style={{
                  marginTop: "22px"
                }}>
                    Setup *
                    {setupLocked && <span className="namo-setup-locked-note">
                        Bei {eventType} ist automatisch Full Setup vorgesehen
                      </span>}
                  </label>
                  <div className="namo-choice-grid namo-setup-grid">
                    {SETUP_TYPES.map(s => {
                    const disabled = setupLocked && s.value !== "Full Setup";
                    return <label key={s.value} className={cn("namo-choice-card", setup === s.value && "active", disabled && "disabled")}>
                          <input type="radio" name="Setup" value={s.value} required checked={setup === s.value} disabled={disabled} onChange={() => setSetup(s.value)} />
                          <span className="namo-choice-check">
                            <svg viewBox="0 0 24 24" fill="none">
                              <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </span>
                          {disabled && <span className="namo-choice-lock">
                              <svg viewBox="0 0 24 24" fill="none">
                                <rect x="5" y="10" width="14" height="10" rx="2" stroke="currentColor" strokeWidth="1.6" />
                                <path d="M8 10V7a4 4 0 018 0v3" stroke="currentColor" strokeWidth="1.6" />
                              </svg>
                            </span>}
                          <div className="namo-choice-icon">{s.icon}</div>
                          <div>
                            <div className="namo-choice-label">{s.label}</div>
                            <div className="namo-choice-hint">{s.hint}</div>
                          </div>
                        </label>;
                  })}
                  </div>
                </div>

                {}
                <div className="namo-section" style={{
                animationDelay: "0.2s"
              }}>
                  <label>
                    Menüauswahl *<br />
                    <small>
                      *Privates Event = max. 4 Pizzen - Berufliches Event = max. 5 Pizzen - Hochzeit = max. 6 Pizzen.
                      Bei Light Setup sind maximal 4 Pizzen wählbar.*
                    </small>
                  </label>

                  {MENU_CATEGORIES.map(cat => <div className="namo-menu-category" style={{
                  "--namo-cat-color": cat.color
                }} key={cat.name}>
                      <div className="namo-menu-category-header">
                        <div className="namo-medallion">{cat.icon}</div>
                        <div className="namo-menu-category-titlewrap">
                          <div className="namo-menu-category-title">
                            {cat.name}
                            <span className="namo-cat-count">
                              {cat.items.length} {cat.items.length === 1 ? "Sorte" : "Sorten"}
                            </span>
                          </div>
                          <div className="namo-menu-category-line" />
                        </div>
                      </div>
                      <div className="namo-menu-grid">
                        {cat.items.map(item => {
                      const checked = selectedMenu.includes(item.value);
                      const disabled = !checked && limitReached;
                      return <label key={item.value} className={cn("namo-pizza-chip", checked && "checked", disabled && "disabled")}>
                              <input type="checkbox" name="Menu[]" value={item.value} checked={checked} disabled={disabled} onChange={() => toggleMenu(item.value)} />
                              {checked && <span className="namo-pizza-check">
                                  <svg viewBox="0 0 24 24" fill="none">
                                    <path d="M5 13l4 4L19 7" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round" />
                                  </svg>
                                </span>}
                              {item.label}
                            </label>;
                    })}
                      </div>
                    </div>)}

                  <span className={cn("namo-counter", limitReached && "full")}>
                    {selectedMenu.length} / {maxPizzas} Pizzen ausgewählt
                  </span>

                  <label>Nachricht</label>
                  <textarea name="Nachricht" placeholder="Schreiben Sie uns gerne eine Nachricht." />
                </div>

                {}
                <div className="namo-section" style={{
                animationDelay: "0.3s"
              }}>
                  <h3>Veranstaltungsort</h3>
                  <label>Straße und Hausnummer</label>
                  <input type="text" name="Ort_Strasse" />

                  <div className="namo-row">
                    <div>
                      <label>Stadt</label>
                      <input type="text" name="Ort_Stadt" />
                    </div>
                    <div>
                      <label>Postleitzahl</label>
                      <input type="text" name="Ort_PLZ" />
                    </div>
                  </div>
                </div>

                <button className="namo-submit" type="submit">
                  Anfrage senden
                </button>
              </form>
            </div>
          </div>

          {}
          <div className={cn("mt-8 mx-auto h-px max-w-md transition-all duration-700", isVisible ? "w-full opacity-100" : "w-0 opacity-0")} style={{
          transitionDelay: isVisible ? "550ms" : "0ms",
          background: "linear-gradient(to right, transparent, var(--primary), transparent)"
        }} />
        </div>

      </div>
    </section>;
}